<div fxLayout="column" fxFill  >
  <mat-form-field appearance="outline">
    <mat-chip-list #chipList [disabled]="disableChipList">
      <mat-chip
        *ngFor="let item of currentValues"
        [selectable]="true"
        [removable]="true"
        (removed)="remove(item)">

      <div *ngIf="firstSelectionViewField === 'descx'">
        {{ 'LABEL.' + item[firstSelectionViewField] | translate }}
      </div>
      <div *ngIf="firstSelectionViewField === 'uiLabel'">
        {{ 'LABEL.' + item[firstSelectionViewField] | translate }}
      </div>
      <div *ngIf="firstSelectionViewField === 'stateCode'">
        {{ 'STATECATEGORIES.' + item['code'] | translate }}
      </div>
      <div *ngIf="firstSelectionViewField === 'branchCode'">
        {{ 'ACTIVITIES.' + item['code'] | translate }} ({{item['codCountry']}})
      </div>
      <div *ngIf="firstSelectionViewField === 'company'">
        {{ item['code'] }}
      </div>
      <div *ngIf="firstSelectionViewField === 'translationGroupCode'">
        {{ item['label'] }}
      </div>
      <div *ngIf="firstSelectionViewField !== '' && firstSelectionViewField !== 'uiLabel' && firstSelectionViewField !== 'descx' && firstSelectionViewField !== 'stateCode' && firstSelectionViewField !== 'translationGroupCode'">
        {{item[firstSelectionViewField]}}
      </div>
      <div *ngIf="firstSelectionViewField === ''">
        {{item}}
      </div>

        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-list>
    <input
      hidden
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"

    />
  </mat-form-field>
  <div [formGroup]="form" fxLayout="row">

    <app-select-search
      formControlName="main"
      [label]="firstSelectionLabel"
      [items]="items"
      [viewField]="firstSelectionViewField"
      [noMatchLabel]="'LABEL.NoSearchResults' | translate"
      fxFlex [noUsers]="noUsers"
    ></app-select-search>

    <mat-form-field *ngIf="showSecondSelection" fxFlex>
      <mat-label>second</mat-label>
      <mat-select formControlName="second">
        <mat-option *ngFor="let item of secondSelectionList" [value]="item">
          <div *ngIf="secondSelectionViewField === 'uiLabel'">
            {{ 'LABEL.' + item[secondSelectionViewField] | translate }}
          </div>
          <div *ngIf="secondSelectionViewField !== ''">
            {{item[secondSelectionViewField]}}
          </div>
          <div *ngIf="secondSelectionViewField !== ''">
            {{item}}
          </div>
          <div *ngIf="secondSelectionViewField === 'descx'">
            {{ 'LABEL.' + item[secondSelectionViewField] | translate }}
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-mini-fab color="primary" *ngIf="showSecondSelection" (click)="add()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
